import { html } from '@rxdi/lit-html';

/**
 * Validation message under a form field (styled by the form's `.error` class).
 * Before @rxdi/forms has bound the form, `form.get(name)` is not an element
 * yet - render nothing until it is.
 */
export function InputErrorTemplate(input: HTMLInputElement | HTMLSelectElement) {
  if (!input || typeof input.checkValidity !== 'function') {
    return '';
  }
  if (!input.checkValidity()) {
    input.classList.add('is-invalid');
    return html`<span class="error">${input.validationMessage}</span>`;
  }
  input.classList.remove('is-invalid');
  return '';
}
